import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.u6r_1 = partyId;
        this.v6r_1 = playerId;
        this.w6r_1 = name;
        this.x6r_1 = email;
        this.y6r_1 = badge;
        this.z6r_1 = callSignAdjective;
        this.a6s_1 = callSignNoun;
        this.b6s_1 = imageURL;
        this.c6s_1 = avatarType;
        this.d6s_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.u6r_1.toString() + ', playerId=' + this.v6r_1.toString() + ', name=' + this.w6r_1 + ', email=' + this.x6r_1 + ', badge=' + this.y6r_1.toString() + ', callSignAdjective=' + this.z6r_1 + ', callSignNoun=' + this.a6s_1 + ', imageURL=' + toString(this.b6s_1) + ', avatarType=' + toString(this.c6s_1) + ', unvalidatedEmails=' + toString(this.d6s_1) + ')';
      }
      hashCode() {
        var result = this.u6r_1.hashCode();
        result = imul(result, 31) + this.v6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.w6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x6r_1) | 0;
        result = imul(result, 31) + this.y6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.z6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6s_1) | 0;
        result = imul(result, 31) + hashCode(this.b6s_1) | 0;
        result = imul(result, 31) + hashCode(this.c6s_1) | 0;
        result = imul(result, 31) + hashCode(this.d6s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.u6r_1.equals(other.u6r_1))
          return false;
        if (!this.v6r_1.equals(other.v6r_1))
          return false;
        if (!(this.w6r_1 === other.w6r_1))
          return false;
        if (!(this.x6r_1 === other.x6r_1))
          return false;
        if (!this.y6r_1.equals(other.y6r_1))
          return false;
        if (!(this.z6r_1 === other.z6r_1))
          return false;
        if (!(this.a6s_1 === other.a6s_1))
          return false;
        if (!equals(this.b6s_1, other.b6s_1))
          return false;
        if (!equals(this.c6s_1, other.c6s_1))
          return false;
        if (!equals(this.d6s_1, other.d6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
